import { getLogger } from './utils/logger-context';
import { resolveComponentScope } from './utils/resolveComponentScope';

const COMPONENT_NAME = 'List';

export const init = (unresolvedScope) => {
    const logger = getLogger();
    const scope = resolveComponentScope(unresolvedScope);
    const defaultLoggerArgs = {
        componentName: COMPONENT_NAME,
        scope,
    };
    logger.debug(`Initialising ${COMPONENT_NAME} component.`, { scope });

    const takoLists = scope.querySelectorAll('.tako-list');

    takoLists.forEach((list) => {
        try {
            const items = list.querySelectorAll('li');

            if (items) {
                items.forEach((listItem) => {
                    listItem.setAttribute('tabindex', '0');
                });
            }
        } catch (error) {
            logger.error(error, {
                ...defaultLoggerArgs,
                element: list,
            });
        }
    });

    const autoSelectLists = scope.querySelectorAll(
        '.tako-list[data-auto-select=true]',
    );

    autoSelectLists.forEach((list) => {
        try {
            const items = list.querySelectorAll('li');

            if (items) {
                items.forEach((listItem) => {
                    listItem.addEventListener('click', () => {
                        items.forEach((item) => {
                            item.classList.remove('tako-list__item--selected');
                        });
                        listItem.classList.add('tako-list__item--selected');
                    });
                });
            }
        } catch (error) {
            logger.error(error, {
                ...defaultLoggerArgs,
                element: list,
            });
        }
    });
};
